// extracted by mini-css-extract-plugin
export default {"panel":"panel_panel__uXUel","scrollBackgroundPosY":"panel_scrollBackgroundPosY__m4q6B","scrollPosX":"panel_scrollPosX__cEumh"};